/* Brandawi - برانداوي | Copyright © Brandawi. Unified wishlist engine (products + recipes) */
(function () {
  var PRIMARY_KEY = 'recipeWishlist';
  var LEGACY_PRODUCT_KEY = 'brandawiProductWishlist';

  var RECIPE_TRIGGER_SELECTOR = '.ftgf-wishlist-btn[data-id], .brwrrs__wishlist-btn[data-id]';
  var PORTAL_PRODUCT_TRIGGER_SELECTOR =
    '.product-form .nm-portal button:not(.nm-wishlist-open-list-button), ' +
    '.product-form .nm-portal a:not(.nm-wishlist-open-list-button), ' +
    '.product-form .nm-portal [class*="wishlist"]:not(.nm-wishlist-open-list-button), ' +
    '.product-form .nm-portal [data-action*="wishlist"]';

  function safeParse(raw) {
    if (!raw) return [];

    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function inferType(item) {
    if (item && item.type) return String(item.type);

    var url = item && item.url ? String(item.url) : '';

    if (/\/products\//.test(url)) return 'product';
    if (/\/blogs\//.test(url) || /\/articles\//.test(url)) return 'recipe';
    return 'recipe';
  }

  function normalizeItem(item) {
    if (item == null) return null;

    if (typeof item === 'string' || typeof item === 'number') {
      return {
        id: String(item),
        url: '',
        title: '',
        img: '',
        type: 'recipe'
      };
    }

    if (typeof item !== 'object' || item.id == null) return null;

    var normalized = {
      id: String(item.id),
      url: item.url ? String(item.url) : '',
      title: item.title ? String(item.title) : '',
      img: item.img ? String(item.img) : '',
      type: item.type ? String(item.type) : ''
    };

    normalized.type = inferType(normalized);
    return normalized;
  }

  function itemKey(item) {
    return inferType(item) + ':' + String(item.id);
  }

  function readWishlist() {
    var raw = []
      .concat(safeParse(localStorage.getItem(PRIMARY_KEY)))
      .concat(safeParse(localStorage.getItem(LEGACY_PRODUCT_KEY)));

    var byKey = {};

    raw.map(normalizeItem).filter(Boolean).forEach(function (item) {
      var key = itemKey(item);
      var existing = byKey[key];

      if (!existing) {
        byKey[key] = item;
        return;
      }

      if (!existing.url && item.url) existing.url = item.url;
      if (!existing.title && item.title) existing.title = item.title;
      if (!existing.img && item.img) existing.img = item.img;
    });

    return Object.keys(byKey).map(function (key) {
      return byKey[key];
    });
  }

  function writeWishlist(items) {
    var payload = JSON.stringify(items);

    try {
      localStorage.setItem(PRIMARY_KEY, payload);
      localStorage.setItem(LEGACY_PRODUCT_KEY, payload);
    } catch (error) {
      return;
    }

    document.dispatchEvent(
      new CustomEvent('brandawi:wishlist:changed', {
        detail: { key: PRIMARY_KEY }
      })
    );
  }

  function findIndexByItem(list, item) {
    var key = itemKey(item);
    return list.findIndex(function (entry) {
      return itemKey(entry) === key;
    });
  }

  function isSaved(list, id, type) {
    return list.some(function (item) {
      return String(item.id) === String(id) && inferType(item) === String(type || inferType(item));
    });
  }

  function setActiveState(button, active) {
    if (!button) return;
    button.classList.toggle('is-active', active);
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function extractStandardItem(button) {
    var id = button.getAttribute('data-id');
    if (!id) return null;

    var card = button.closest('.ftgf-card, .rt-card, .wishlist-item-card, .article');
    var linkEl = card ? card.querySelector('a[href]') : null;
    var imageEl = card ? card.querySelector('img') : null;
    var titleEl = card ? card.querySelector('h1, h2, h3, h4, h5, .wishlist-item-title') : null;

    var item = {
      id: String(id),
      url: button.getAttribute('data-url') || (linkEl ? linkEl.getAttribute('href') : ''),
      title: button.getAttribute('data-title') || (titleEl ? titleEl.textContent : '') || document.title,
      img: button.getAttribute('data-img') || (imageEl ? imageEl.getAttribute('src') : '') || '',
      type: button.getAttribute('data-type') || ''
    };

    item.type = inferType(item);
    return item;
  }

  function extractProductItemFromSection(section) {
    if (!section) return null;

    var id = section.getAttribute('data-product-id');
    if (!id) return null;

    return {
      id: String(id),
      url: section.getAttribute('data-product-url') || window.location.pathname,
      title: section.getAttribute('data-product-title') || document.title,
      img: section.getAttribute('data-product-image') || '',
      type: 'product'
    };
  }

  function toggleItem(item) {
    var list = readWishlist();
    var index = findIndexByItem(list, item);

    if (index > -1) {
      list.splice(index, 1);
      writeWishlist(list);
      return false;
    }

    list.push(item);
    writeWishlist(list);
    return true;
  }

  function syncRecipeButtons(list) {
    document.querySelectorAll(RECIPE_TRIGGER_SELECTOR).forEach(function (button) {
      var id = button.getAttribute('data-id');
      if (!id) return;

      var type = button.getAttribute('data-type');
      var itemType = type ? String(type) : inferType({ url: button.getAttribute('data-url') || '' });
      var active = isSaved(list, id, itemType);
      setActiveState(button, active);
    });
  }

  function syncProductButtons(list) {
    document.querySelectorAll('.main-product-page[data-product-id]').forEach(function (section) {
      var productId = section.getAttribute('data-product-id');
      if (!productId) return;

      var active = isSaved(list, productId, 'product');
      section.querySelectorAll(PORTAL_PRODUCT_TRIGGER_SELECTOR).forEach(function (trigger) {
        setActiveState(trigger, active);
      });
    });
  }

  function createWishlistCard(item) {
    var card = document.createElement('article');
    card.className = 'wishlist-item-card wishlist-item-card--' + inferType(item);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'ftgf-wishlist-btn is-active';
    removeBtn.setAttribute('aria-label', 'Remove from wishlist');
    removeBtn.setAttribute('aria-pressed', 'true');
    removeBtn.setAttribute('data-id', item.id || '');
    removeBtn.setAttribute('data-url', item.url || '');
    removeBtn.setAttribute('data-title', item.title || '');
    removeBtn.setAttribute('data-img', item.img || '');
    removeBtn.setAttribute('data-type', inferType(item));
    removeBtn.innerHTML = '<svg class="heart-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" shape-rendering="geometricPrecision"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';

    var link = document.createElement('a');
    link.className = 'wishlist-item-link';
    link.href = item.url || '/';

    var media = document.createElement('div');
    media.className = 'wishlist-item-media';

    if (item.img) {
      var img = document.createElement('img');
      img.loading = 'lazy';
      img.src = item.img;
      img.alt = item.title || 'Wishlist item';
      media.appendChild(img);
    }

    var body = document.createElement('div');
    body.className = 'wishlist-item-body';

    var kicker = document.createElement('span');
    kicker.className = 'wishlist-item-kicker';
    kicker.textContent = inferType(item) === 'product' ? 'Product' : 'Recipe';

    var title = document.createElement('h3');
    title.className = 'wishlist-item-title';
    title.textContent = item.title || (inferType(item) === 'product' ? 'Saved product' : 'Saved recipe');

    var cta = document.createElement('span');
    cta.className = 'wishlist-item-cta';
    cta.textContent = inferType(item) === 'product' ? 'View Product' : 'View Full Recipe';

    body.appendChild(kicker);
    body.appendChild(title);
    body.appendChild(cta);

    link.appendChild(media);
    link.appendChild(body);

    card.appendChild(removeBtn);
    card.appendChild(link);

    return card;
  }

  function renderWishlistPage(list) {
    var productsSection = document.getElementById('wishlist-products-section');
    var recipesSection = document.getElementById('wishlist-recipes-section');
    var productsGrid = document.getElementById('wishlist-products-grid');
    var recipesGrid = document.getElementById('wishlist-recipes-grid');
    var loading = document.getElementById('wishlist-loading');
    var empty = document.getElementById('wishlist-empty');

    if (!productsSection || !recipesSection || !productsGrid || !recipesGrid) return;

    var products = list.filter(function (item) { return inferType(item) === 'product'; });
    var recipes = list.filter(function (item) { return inferType(item) !== 'product'; });

    productsGrid.innerHTML = '';
    recipesGrid.innerHTML = '';

    if (products.length) {
      var productsFrag = document.createDocumentFragment();
      products.forEach(function (item) { productsFrag.appendChild(createWishlistCard(item)); });
      productsGrid.appendChild(productsFrag);
      productsSection.style.display = '';
    } else {
      productsSection.style.display = 'none';
    }

    if (recipes.length) {
      var recipesFrag = document.createDocumentFragment();
      recipes.forEach(function (item) { recipesFrag.appendChild(createWishlistCard(item)); });
      recipesGrid.appendChild(recipesFrag);
      recipesSection.style.display = '';
    } else {
      recipesSection.style.display = 'none';
    }

    if (loading) loading.style.display = 'none';

    if (!products.length && !recipes.length) {
      if (empty) empty.style.display = 'block';
    } else if (empty) {
      empty.style.display = 'none';
    }
  }

  function syncAll() {
    var list = readWishlist();
    syncRecipeButtons(list);
    syncProductButtons(list);
    renderWishlistPage(list);
  }

  function handleClick(event) {
    var standardTrigger = event.target.closest(RECIPE_TRIGGER_SELECTOR);
    if (standardTrigger) {
      event.preventDefault();
      event.stopPropagation();

      var standardItem = extractStandardItem(standardTrigger);
      if (standardItem) {
        toggleItem(standardItem);
        syncAll();
      }
      return;
    }

    var portalProductTrigger = event.target.closest(PORTAL_PRODUCT_TRIGGER_SELECTOR);
    if (portalProductTrigger && portalProductTrigger.closest('.main-product-page')) {
      event.preventDefault();
      event.stopPropagation();

      var section = portalProductTrigger.closest('.main-product-page[data-product-id]');
      var portalItem = extractProductItemFromSection(section);

      if (portalItem) {
        toggleItem(portalItem);
        syncAll();
      }
    }
  }

  function init() {
    document.addEventListener('click', handleClick, true);
    document.addEventListener('brandawi:wishlist:changed', syncAll);
    document.addEventListener('shopify:section:load', syncAll);

    window.addEventListener('storage', function (event) {
      if (event.key === PRIMARY_KEY || event.key === LEGACY_PRODUCT_KEY) {
        syncAll();
      }
    });

    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
